// A long-press shortcut on the installed icon (INSTALL.md §4.1, M1's P1 Also):
// My Team, Matchup or Scores, in the league opened last.
//
// A SHORTCUT'S ADDRESS IS FIXED in the manifest, and a league's is not, so the
// shortcut lands here and this sends it on: to the league this device last
// opened, which is the one somebody in several leagues means nine times in
// ten. A device that has opened none, or whose last league is gone, goes to
// the hub, where every league is one tap away — the league route's own guard
// sends an id it does not know there too.

import { useEffect } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { storageKey } from '../data/storage';
import type { ShortcutWhere } from './manifest';

const LAST_LEAGUE = storageKey('last-league.v1');

const PATH: Record<ShortcutWhere, string> = {
  team: '',
  matchup: '/matchup',
  scores: '/scoreboard',
};

/** The league this device opened last, or null. */
export function lastLeague(): string | null {
  try {
    const id = localStorage.getItem(LAST_LEAGUE);
    return id !== null && /^[A-Za-z0-9_-]+$/.test(id) ? id : null;
  } catch {
    return null;
  }
}

/** Remember a real league as the one opened last. Rendered by the league route. */
export function RememberLeague({ id }: { id: string }) {
  useEffect(() => {
    try {
      localStorage.setItem(LAST_LEAGUE, id);
    } catch {
      // Storage blocked: a shortcut lands on the hub instead, which still works.
    }
  }, [id]);
  return null;
}

export function goToPath(where: string | undefined, league: string | null): string {
  if (league === null || where === undefined || !Object.hasOwn(PATH, where)) return '/';
  return `/l/${league}${PATH[where as ShortcutWhere]}`;
}

export function GoTo() {
  const { where } = useParams();
  return <Navigate to={goToPath(where, lastLeague())} replace />;
}
